import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import { map, findIndex } from "lodash";

import { assignmentSliceActions } from "../../Store/Slices/AssignSlice";
import { getTaskList } from "./Services";

// Global variables

// Component
function TaskSelection(props) {
  // Hooks
  const dispatch = useDispatch();

  // State
  const [taskList, setTaskList] = useState(null);

  // Redux state
  let { product, selectedTasks, mode } = useSelector((state) => state.assignment);
  let { userInfo } = useSelector((state) => state.loggedInUserInfo);

  // React logic hooks
  useEffect(() => {
    if (props.type) {
      const getTasks = async () => {
        let tasks = await getTaskList(
          userInfo.uid,
          userInfo.site_uuid,
          product,
          props.type
        );
        setTaskList(tasks.data);
        console.log("tasks.data", tasks.data);
      };
      getTasks();
    }
  }, [product, userInfo, props.type]);

  // Add & Remove tasks from selection
  const addInTask = (val) => {
    if(props.type == 'library' && selectedTasks && selectedTasks.length > 0){
      dispatch(assignmentSliceActions.removeTask(selectedTasks[0].id));
    }
    if (selectedTasks && findIndex(selectedTasks, { id: val.uid }) == -1) {
      dispatch(
        assignmentSliceActions.addTask({
          id: val.uid,
          name: val.title,
          estimated_time: val.estimated_time,
          assets: val.data1.exersices,
        })
      );
    } else {
      dispatch(assignmentSliceActions.removeTask(val.uid));
    }
  };

  // JSX template
  return (
    <>
      <Typography
        color="#5f5600ff"
        sx={{
          ml: 4,
          mt: 2,
          letterSpacing: 1,
          fontSize: "1.2rem",fontWeight: '500',
          '@media (min-width: 1636px)': {
            fontSize: '1.4rem'
          }
        }}
      >
        Select Task:
      </Typography>
      <FormControl fullWidth sx={{ mx: 1, mb: 1 }} size="small">
        {selectedTasks && (
          <Select
            value={selectedTasks}
            displayEmpty
            placeholder="Select Task"
            inputProps={{ "aria-label": "Without label" }}
            sx={{
              borderRadius: 5,
              borderColor: "#FFFFFF",
              backgroundColor: "#F5F5F5",
              '@media (min-width: 1636px)': {
                fontSize: '1.4rem'
              }
            }}
            multiple
            renderValue={(selected) => {
              return map(selected, "name").join(", ");
            }}
            disabled={mode == "edit"}
          >
            {taskList &&
              taskList.map((val, index) => {
                return (
                  <Grid container key={`${index}_Task`}>
                    <Grid item xs={2}>
                      <Checkbox
                        checked={
                          findIndex(selectedTasks, {
                            id: val.uid,
                          }) > -1
                        }
                        onClick={() => addInTask(val)}
                      />
                    </Grid>
                    <Grid item xs={10} sx={{ paddingTop: 0.8, cursor: 'pointer' }}>
                      <ListItemText primary={val.title} onClick={() => addInTask(val)}/>
                    </Grid>
                  </Grid>
                );
              })}
          </Select>
        )}
      </FormControl>
    </>
  );
}

export default TaskSelection;
